module.exports = __webpack_public_path__ + "static/media/reaction-social-badge.95d7a061.svg";